
import React, { ReactNode } from 'react';

interface DetailItemProps {
  icon: ReactNode;
  label: string;
  value: string | ReactNode;
  className?: string;
}

export const DetailItem: React.FC<DetailItemProps> = ({ icon, label, value, className = '' }) => {
  return (
    <div className={`flex flex-col py-2 ${className}`}>
        <div className="flex items-center mb-1">
            <span className="text-brand-teal mr-2">{icon}</span>
            <span className="text-sm font-medium text-gray-600 dark:text-dark-text-secondary">{label}</span>
        </div>
        <div className="pl-7 text-base text-gray-900 dark:text-dark-text-primary break-words">
            {value}
        </div>
    </div>
  );
};